import { Col, Modal, Row } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import "../../../../assets/style/modalStyle/addAccount.scss";

import { useState } from "react";
import { storeProductSelector } from "../../../../services/selector/index.";
import {
  addCategory,
  setOpenModalAddCategory,
} from "../../../../services/slice/StoreSlice";
import TranslateText from "../../TranslateText";
import BaseButton from "../../Button/BaseButton";
import LabelInput from "../../LabelInput";
import InputText from "../../Input/InputText";

const ModalAddCategory = () => {
  const stateStore = useSelector(storeProductSelector);
  const [dataAdd, setDataAdd] = useState({
    name: "",
  });
  const { isOpenModalAddCategry } = stateStore;
  const dispatch = useDispatch();
  const handleCancel = () => {
    dispatch(setOpenModalAddCategory(false));
  };
  const handleSave = () => {
    dispatch(addCategory(dataAdd));
  };
  return (
    <>
      <Modal
        maskClosable={false}
        title={<TranslateText text={"Thêm loại sản phẩm"} />}
        centered
        open={isOpenModalAddCategry}
        className="warrperModalAddAcc"
        footer={[
          <div className="evenSpace">
            <BaseButton
              content={"Hủy bỏ"}
              typeBtn="btnCancel"
              width={155}
              handleClick={handleCancel}
            />
            <BaseButton
              isEnter={true}
              width={155}
              content={"Lưu"}
              typeBtn="mainBtn"
              handleClick={handleSave}
            />
          </div>,
        ]}
        onCancel={handleCancel}
      >
        <Row align={"middle"}>
          <Col span={8}>
            <LabelInput text={"Tên loại sản phẩm"} />
          </Col>
          <Col span={16}>
            <InputText
              focus
              setText={(value) => setDataAdd({ name: value })}
              typeInput={"baseInput"}
              placeholder={"Nhập loại sản phẩm"}
            />
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default ModalAddCategory;
